import React, { useContext, useEffect, useState } from "react";
import { DashboardContext } from "states/DashboardContext";
import CensusLoadingCmp from "./CensusLoadingCmp";
import CustomPivotTable from "./CensusPivotTable";

const CensusTableLayout = () => {
  const {
    languageState,
    censusDefaultMapDataState,
    censusIsDefaultDataState,
    censusMapDataState,
    censusSelectedIndicatorState,
    selectedYearState,
    loadingState,
    filterItemState,
    rowItemState,
    columnItemState,
    censusSelectedAreasState,
  } = useContext(DashboardContext);

  const [language] = languageState;
  const [censusDefaultMapData, setCensusDefaultMapData] =
    censusDefaultMapDataState;
  const [censusIsDefaultData, setCensusIsDefaultData] =
    censusIsDefaultDataState;
  const [censusMapData] = censusMapDataState;
  const [censusSelectedIndicator] = censusSelectedIndicatorState;
  const [selectedYear] = selectedYearState;
  const [censusSelectedAreas, setCensusSelectedAreas] =
    censusSelectedAreasState;
  const [loading] = loadingState;
  const [filterItem, setFilterItem] = filterItemState;
  const [rowItem, setRowItem] = rowItemState;
  const [columnItem, setColumnItem] = columnItemState;

  const areas = censusSelectedAreas?.map((area) => area.areakey);
  const data = censusMapData
    ?.filter((data) => areas.includes(data.areakey))
    .sort((a, b) => b.time_name - a.time_name);

  useEffect(() => {}, [censusMapData]);
  const [state, setState] = useState({});

  return (
    <div>
      {loading ? <CensusLoadingCmp /> : <CustomPivotTable data={data} />}
    </div>
  );
};

export default CensusTableLayout;
